import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../services/auth';

const styles = {
    wrapper: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: '20px',
    },
    card: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderRadius: '20px',
        padding: '48px 40px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
    },
    logo: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '8px',
    },
    logoImg: {
        height: '40px',
        objectFit: 'contain',
    },
    title: {
        textAlign: 'center',
        fontSize: '22px',
        fontWeight: '700',
        color: '#1a1a2e',
        marginBottom: '4px',
    },
    subtitle: {
        textAlign: 'center',
        fontSize: '14px',
        color: '#64748b',
        marginBottom: '32px',
    },
    fieldGroup: {
        marginBottom: '20px',
    },
    label: {
        display: 'block',
        fontSize: '13px',
        fontWeight: '500',
        color: '#475569',
        marginBottom: '6px',
    },
    input: {
        width: '100%',
        padding: '12px 16px',
        fontSize: '14px',
        border: '1.5px solid #e2e8f0',
        borderRadius: '10px',
        outline: 'none',
        transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
        background: '#f8fafc',
        color: '#1a1a2e',
        boxSizing: 'border-box',
    },
    button: {
        width: '100%',
        padding: '13px',
        fontSize: '15px',
        fontWeight: '600',
        color: '#ffffff',
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        border: 'none',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'transform 0.15s ease, box-shadow 0.2s ease',
        boxShadow: '0 4px 14px rgba(99, 102, 241, 0.35)',
        marginTop: '8px',
    },
    error: {
        marginTop: '16px',
        padding: '10px 14px',
        background: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '8px',
        color: '#dc2626',
        fontSize: '13px',
        textAlign: 'center',
    },
};

const Login = () => {
    // if (localStorage.getItem('token')) {
    //     window.location.href = '/dashboard';
    // }

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        try {
            const data = await loginUser(username, password);
            // Par exemple, stocker le token
            navigate('/dashboard'); // Redirige vers le dashboard ou la page protégée
        } catch (err) {
            setError(err.response?.data?.message || 'Erreur lors de l\'authentification');
        }
    };

    return (
        <div style={styles.wrapper}>
            <div style={styles.card}>
                <div style={styles.logo}>
                    <img src="/assets/logos/nVisio.png" alt="nVisio" style={styles.logoImg} />
                </div>
                <h1 style={styles.title}>Bienvenue</h1>
                <p style={styles.subtitle}>Connectez-vous à votre espace</p>
                <form onSubmit={handleSubmit}>
                    <div style={styles.fieldGroup}>
                        <label htmlFor="username" style={styles.label}>Nom d'utilisateur</label>
                        <input
                            type="text"
                            id="username"
                            placeholder="Entrez votre identifiant"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            style={styles.input}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#6366f1';
                                e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.12)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                    <div style={styles.fieldGroup}>
                        <label htmlFor="password" style={styles.label}>Mot de passe</label>
                        <input
                            type="password"
                            id="password"
                            placeholder="Entrez votre mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={styles.input}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#6366f1';
                                e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.12)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#e2e8f0';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                    </div>
                    <button
                        type="submit"
                        style={styles.button}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 6px 20px rgba(99, 102, 241, 0.45)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 14px rgba(99, 102, 241, 0.35)';
                        }}
                    >
                        Se connecter
                    </button>
                    {error && <div style={styles.error}>{error}</div>}
                </form>
            </div>
        </div>
    );
};

export default Login;